export default __webpack_public_path__ + "static/media/line4.08f2f0af.svg";